import React from 'react'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import { IProduct } from '@common/interface/product'
import parse from 'html-react-parser'
import { containsHtml, preserveBlankLines } from '@lib/util/string'
import richTextSpacing from '@theme/rich-text.theme'

interface PropsType {
  item: IProduct
  showBorderBottom: boolean
}

const ProductInfoDetail: React.FC<PropsType> = ({
  item,
  showBorderBottom = false
}) => {
  const description = item?.description || ''
  const isHtml = containsHtml(description)

  return (
    <Stack>
      <Flex borderBottom={'1.5px solid'} pb="14px">
        <Text textStyle="productTitleMedium" fontFamily="ITC">
          Product Detail
        </Text>
      </Flex>
      <Box
        pt={6}
        mt="0!"
        mb={5}
        textStyle="productDetailSmall"
        // Plain text descriptions keep the line breaks typed in the admin; markup lays itself
        // out with its own tags, so collapsing whitespace is the right thing to do there.
        whiteSpace={isHtml ? undefined : 'pre-line'}
        sx={richTextSpacing}
      >
        {item && parse(isHtml ? preserveBlankLines(description) : description)}
      </Box>
      {showBorderBottom && (
        <Flex
          justifyContent={'space-between'}
          alignItems={'center'}
          py={2}
          borderBottom={'1.5px solid'}
        ></Flex>
      )}
    </Stack>
  )
}

export default ProductInfoDetail
